import { Injectable } from "@angular/core";
import { ProductService } from "./product.service";
import { EbayService } from "./ebay.service";
import { Product, ProductBase } from "../interfaces";
import { Observable } from "rxjs";
import { EbayProduct, EbayStock } from "../interfaces/ebay";

@Injectable({
  providedIn: 'root'
})
export class InputService {
  constructor(
    private productService: ProductService,
    private ebayService: EbayService,
  ) { }

  patchProduct(productId: number, data: Partial<ProductBase>): Observable<Product> {
    return this.productService.patch(productId, data);
  }

  patchEbayProduct(ebayProductId: number, data: Partial<EbayProduct>): Observable<EbayProduct> {
    return this.ebayService.patchEbayProduct(ebayProductId, data);
  }

  patchEbayStock(ebayStockId: number, data: Partial<EbayStock>): Observable<EbayStock> {
    return this.ebayService.patchEbayStock(ebayStockId, data);
  }
}